<div class="thresholds-configuration">
    <div *ngIf="!threshold" class="no-thresholds-defined">No thresholds rules were defined</div>
    <div *ngIf="threshold" class="form-table-column">
        <arm-form (submitForm)="onSubmit()" [disableSubmit]="!isAuthorized || threshold.thresholds.length < 1 || isStatisticInEditMode()">
            <div class="form-container">
                <div class="general-settings">
                    <arm-form-title>GENERAL</arm-form-title>
                    <div>
                        <mat-checkbox [(ngModel)]="threshold.enable" color="primary" name="enabled">
                            Enabled
                        </mat-checkbox>
                        <mat-form-field class="fullWidth">
                            <mat-label>Name</mat-label>
                            <input matInput [(ngModel)]="threshold.name" [disabled]="!isAuthorized" name="name" required>
                            <mat-error>
                                Name is <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="fullWidth">
                            <mat-label>Type</mat-label>
                            <mat-select [(ngModel)]="threshold.elementType" [disabled]="threshold.id >= 0 || !isAuthorized"
                                        (selectionChange)="resetThreshold(); onElementTypeChange($event.value);" name="elementType">
                                <mat-option *ngFor="let item of elementTypeOptions" [value]="item.value">
                                    {{item.label}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="fullWidth">
                            <mat-label>Severity</mat-label>
                            <mat-select [(ngModel)]="threshold.alarmSeverity" [disabled]="!isAuthorized" name="alarmSeverity">
                                <mat-option *ngFor="let item of alertTypeOptions" [value]="item.value">
                                    {{item.label}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="fullWidth">
                            <mat-label>Elements</mat-label>
                            <mat-select multiple [(ngModel)]="threshold.elementIds" (selectionChange)="displaySelectedStatistic()"
                                        [disabled]="threshold.elementType === 'arm' || threshold.allElements || !isAuthorized" name="elementIds">
                                <mat-option *ngFor="let item of elementOptions" [value]="item.id">
                                    {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-checkbox (change)="onAllElementsChanged()" [(ngModel)]="threshold.allElements" color="primary" name="allElements"
                                      [disabled]="threshold.elementType === 'arm' || !isAuthorized">
                            Select All
                        </mat-checkbox>
                    </div>

                    <arm-form-title>Thresholds</arm-form-title>
                    <div>
                      <div class="threshold-inner-actions">
                        <arm-action-bar  (addClick)="addStatistic()" [disableAdd]="!(isAddStatisticEnabled() && isAuthorized)" [addTooltip]="'Add threshold'"
                                        (deleteClick)="deleteStatistic()" [disableDelete]="!(this.selection?.selected?.length === 1 && isAuthorized)" [deleteTooltip]="'Delete threshold'">
                        </arm-action-bar>
                      </div>


                      <!--
                        <div class="statistic-threshold-actions">
                                <span class="material-icons" (click)="addStatistic()"
                                      *ngIf="isAddStatisticEnabled() && isAuthorized"
                                      matTooltip="Add threshold">add</span>
                            <span class="material-icons" (click)="deleteStatistic()"
                                  *ngIf="this.selection?.selected?.length === 1 && isAuthorized"
                                  matTooltip="Remove threshold">delete</span>
                        </div>
                        -->
                        <div class="table-container" #statisticTable>
                            <table mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="{{col}}" *ngFor="let col of displayedColumns">
                                    <th mat-header-cell *matHeaderCellDef>
                                            <span *ngIf="col !== '$$edit'">
                                              {{displayedColumnsNames[col]}}
                                            </span>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="statistic-cell" [ngClass]="dataSchema[col]">
                                        <div *ngIf="!element.isEdit">
                                            <div class="statistics-actions" *ngIf="col === '$$edit' && !isStatisticInEditMode(); spanHeader">
                                                    <span class="material-icons" *ngIf="isAuthorized"
                                                          (click)="editStatistic(element)">edit</span>
                                                <mat-icon *ngIf="element.alarmsCount" class="notification"
                                                          (click)="$event.stopPropagation();$event.preventDefault();navigateToAlarms(element);"
                                                          [matBadge]="element.alarmsCount" matBadgeSize="small">notifications_none</mat-icon>
                                            </div>
                                            <span *ngIf="col !== 'statisticType'">{{element[col]}}</span>
                                            <span *ngIf="col === 'statisticType'">{{getStatisticName(element[col])}}</span>
                                        </div>
                                        <div *ngIf="element.isEdit">
                                            <div class="statistics-actions" *ngIf="col === '$$edit'; else defaultField">
                                                    <span class="material-icons"
                                                          *ngIf="watermarkControls.lowWatermark.valid && watermarkControls.highWatermark.valid && isValidStatistic(element) && isAuthorized"
                                                          (click)="$event.stopPropagation();$event.preventDefault();submitStatistic(element);displaySelectedStatistic(element)">done</span>
                                                <mat-icon *ngIf="element.alarmsCount" (click)="$event.stopPropagation();$event.preventDefault();navigateToAlarms(element)"
                                                          [matBadge]="element.alarmsCount" matBadgeSize="small">notifications_none</mat-icon>
                                            </div>
                                            <ng-template #defaultField>
                                                <div *ngIf="dataSchema[col] === 'number'">
                                                    <mat-form-field>
                                                        <input [type]="dataSchema[col]" matInput
                                                               (click)="$event.stopPropagation()"
                                                               [formControl]="watermarkControls[col]"
                                                               [(ngModel)]="element[col]">

                                                        <mat-error *ngIf="watermarkControls[col]?.errors?.required">Required</mat-error>
                                                        <mat-error *ngIf="watermarkControls[col]?.errors?.min">Minimum 1</mat-error>
                                                        <mat-error *ngIf="watermarkControls[col]?.errors?.pattern?.requiredPattern">Only integers allowed</mat-error>
                                                      </mat-form-field>
                                                </div>
                                                <div *ngIf="dataSchema[col] === 'select'">
                                                    <mat-select [(ngModel)]="element[col]" (click)="$event.stopPropagation()" (selectionChange)="onStatChange($event)">
                                                        <mat-option *ngFor="let item of availableStatisticsOptions" [value]="item.statisticType" >
                                                            {{item.statisticName}}
                                                        </mat-option>
                                                    </mat-select>


                                                  <span class="error-message" *ngIf="watermarkControls.lowWatermark.valid && watermarkControls.highWatermark.valid &&
                                                        !isValidStatistic(element)">Clear threshold should be lower than the trigger threshold</span>

                                                </div>
                                            </ng-template>
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                <tr mat-row (click)="selection.select(row); displaySelectedStatistic(row)"
                                    *matRowDef="let row; columns: displayedColumns;"
                                    [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"></tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="statistics-graph">
                    <arm-form-title>Current Statistics Values</arm-form-title>
                    <arm-highchart #statistics [options]="chartOptions"></arm-highchart>
                </div>
            </div>
        </arm-form>
    </div>
</div>
